import axios from 'axios'
import app from '@/main'
import { API_BASE_URL } from '@/config.js'

axios.defaults.withCredentials = true

const apiClient = axios.create({
  baseURL: API_BASE_URL
})

apiClient.interceptors.request.use(async (config) => {
  try {
    if (config.url === '/login_n' || config.url === '/enviar_codigo_confirmacion' || config.url === '/verificar_codigo_confirmacion' || config.url === '/recuperar_clave' || config.url === '/cliente/registrar') {
      const token = await app.config.globalProperties.$recaptcha('login_n')
      config.headers['X-Recaptcha-Token'] = token
    }

    return config
  } catch (error) {
    console.error('Error al generar el token de reCAPTCHA:', error)
    return config
  }
}, (error) => {
  return Promise.reject(error)
})

export async function get (url, config) {
  try {
    app.config.globalProperties.$store.dispatch('loading/showPreloader')
    const response = await apiClient.get(url, config)
    app.config.globalProperties.$store.dispatch('loading/hidePreloader')
    return response
  } catch (error) {
    app.config.globalProperties.$store.dispatch('loading/hidePreloader')
    return error.response
  }
}

export async function post (url, data, config) {
  try {
    app.config.globalProperties.$store.dispatch('loading/showPreloader')
    const response = await apiClient.post(url, data, config)
    app.config.globalProperties.$store.dispatch('loading/hidePreloader')
    return response
  } catch (error) {
    app.config.globalProperties.$store.dispatch('loading/hidePreloader')
    return error.response
  }
}
